import { render, staticRenderFns } from "./ComplaintFollowUps.vue?vue&type=template&id=eeda9fc0&scoped=true&"
import script from "./ComplaintFollowUps.vue?vue&type=script&lang=js&"
export * from "./ComplaintFollowUps.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintFollowUps.vue?vue&type=style&index=0&id=eeda9fc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeda9fc0",
  null
  
)

export default component.exports